// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"275":"phone_search","327":"take_notes"}[chunkId] + "." + {"275":"5c734132","327":"d8c0a0b8"}[chunkId] + ".css";
};